import clsx from 'clsx';
import { Tooltip as ReactTooltip } from 'react-tooltip';

import styles from './Tooltip.module.scss';

interface Props {
  id: string;
  text: string;
  className?: string;
  place?: 'top' | 'bottom' | 'left' | 'right';
}

export default function Tooltip({
  id,
  text,
  className,
  place = 'bottom',
}: Props) {
  return (
    <ReactTooltip
      className={clsx(styles.tooltip, className)}
      id={id}
      place={place}
      content={text}
      role="tooltip"
    />
  );
}
